const radii = {
  none: "0",
  sm: "0.125rem",
  base: "0.1875rem",
  md: "0.25rem",
  lg: "0.375rem",
  xl: "0.5rem",
  "2xl": "0.75rem",
  "3xl": "1rem",
}

export default radii
